
import { Getter, GetterTree } from "vuex";
import State from "./state";
import { IUserLoginInfoModel } from "src/model";

export function profile(state: State): IUserLoginInfoModel
{
    let profile = state.profile;

    if(!profile)
    {
        let profileStorage = localStorage.getItem("profile") || "";
        profile = profileStorage && JSON.parse(profileStorage) || null;
    }
    
    return profile;
}

export default <GetterTree<State, any>>
{
    profile
};
